// Import model
import { UpdateLeadRequest } from '../models/UpdateLeadRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateLeadRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateLeadRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateLeadRequest instance
   */
  static deserialize(json: string): UpdateLeadRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateLeadRequest instance
   */
  static fromObject(obj: any): UpdateLeadRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateLeadRequest');
    }


    const instance: UpdateLeadRequest = {
      fullName: obj['fullName'] as string | undefined,
      phone: obj['phone'] as string | undefined,
      email: obj['email'] as string | undefined,
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      state: obj['state'] as string | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      country: obj['country'] as string | undefined,
      userId: obj['userId'] as string | undefined,
      phonePreferences: obj['phonePreferences'] as string | undefined,
      smsPreferences: obj['smsPreferences'] as string | undefined,
      emailPreferences: obj['emailPreferences'] as string | undefined,
      notes: obj['notes'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateLeadRequest instances
   */
  static deserializeArray(json: string): UpdateLeadRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateLeadRequest instance to a JSON string
   */
  static serialize(instance: UpdateLeadRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateLeadRequest instance to a plain object
   */
  static toObject(instance: UpdateLeadRequest): any {
    return {
      'fullName': instance.fullName,
      'phone': instance.phone,
      'email': instance.email,
      'address': instance.address,
      'city': instance.city,
      'state': instance.state,
      'postalCode': instance.postalCode,
      'country': instance.country,
      'userId': instance.userId,
      'phonePreferences': instance.phonePreferences,
      'smsPreferences': instance.smsPreferences,
      'emailPreferences': instance.emailPreferences,
      'notes': instance.notes,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of UpdateLeadRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateLeadRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
